import {NgModule} from '@angular/core';
import {I18nService} from './services/i18n.service';
import {RateRemoteService} from './services/remote/rate-remote.service';
import {RedsysRemoteService} from './services/remote/payment/redsys-remote.service';
import {PaymentRemoteService} from './services/remote/payment/payment-remote.service';
import {LoaderService} from './services/loader.service';
import {ThumbnailRemoteService} from '../services/thumbnail-remote.service';
import {UserRemoteService} from './services/remote/user/user.remote.service';
import {SectorRemoteService} from './services/remote/common/sector-remote.service';
import {ResponsiveService} from './services/responsive.service';
import {AppConfigService} from '../services/config/app-config.service';
import {AppConfigLoaderService} from '../services/config/app-config-loader.service';
import {AuthenticationService} from '../services/security/authentication.service';
import {SocialAuthService} from 'angularx-social-login';
import {StorageService} from '../services/storage/storage.service';
import {ProjectFilesRemoteService} from './services/remote/project/project-files-remote.service';
import {RegionRemoteService} from './services/remote/common/region-remote.service';
import {Ec2RemoteService} from './services/remote/amazon/ec2-remote.service';


@NgModule({
  declarations: [],
  imports: [],
  exports: [],
  providers: [
    I18nService,
    RateRemoteService,
    RedsysRemoteService,
    PaymentRemoteService,
    LoaderService,
    ThumbnailRemoteService,
    UserRemoteService,
    SectorRemoteService,
    ResponsiveService,
    AppConfigService,
    AppConfigLoaderService,
    AuthenticationService,
    StorageService,
    ProjectFilesRemoteService,
    RegionRemoteService,
    Ec2RemoteService
  ]
})
export class CoreModule { }
